module.exports = __webpack_public_path__ + "img/printer.46d0e45c.gif";